import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'

export const noResultTitle = (theme: Theme): SerializedStyles =>
  css({
    paddingBottom: theme.spacing(1),
  })

export const noResultText = (theme: Theme): SerializedStyles =>
  css({
    padding: theme.spacing('0', 2),
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing('0', 3),
    },
  })
